<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

            <div class="tip-bar">
                <i class="el-icon-warning-outline"></i>
                <span>课堂质量管理员可在手机端查看授权校区的点评记录与班级排行。请至少选择一个校区。</span>
            </div>

            <div class="tbl-scroll-host">
                <el-table :data="rows" v-loading="listLoading" class="compact-table" height="100%" style="width: 100%;">
                    <el-table-column prop="TeacherName" label="姓名" min-width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column label="授权校区" min-width="220" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ formatCampuses(scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="90" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.Enabled ? 'success' : 'danger'" size="small">
                                {{ scope.row.Enabled ? '启用' : '禁用' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="CreateTime" label="创建时间" width="170" align="center"></el-table-column>
                    <el-table-column label="操作" width="150" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" type="warning" @click="handleEdit(scope.row)">编辑</el-button>
                            <el-button size="mini" type="danger" @click="handleDel(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="pagination-container">
                <el-pagination layout="total,prev, pager, next" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="page" :page-size="pageSize" :total="total"
                    style="float: right"></el-pagination>
            </div>

            <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="560px" :close-on-click-modal="false">
                <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
                    <el-form-item label="教职工" prop="TeacherMasterId">
                        <div class="ps-pick-summary">
                            <span v-if="editForm.TeacherMasterId">
                                已选 <strong>{{ selectedPersonLabel || ('教职工#' + editForm.TeacherMasterId) }}</strong>
                            </span>
                            <span v-else class="muted-text">请选择一名教职工</span>
                            <el-button type="primary" size="mini" plain @click="openPersonPicker">选择教职工</el-button>
                            <el-button v-if="editForm.TeacherMasterId" type="text" size="mini" @click="clearSelectedPerson">清空</el-button>
                        </div>
                        <div class="form-tip">从通讯录选择，仅绑定一人</div>
                    </el-form-item>
                    <el-form-item label="授权校区" prop="CampusIds">
                        <!-- 校区通常不多，默认全部展示；超过 5 个再折叠为 +N。最后更新：2026-10-31 -->
                        <el-select
                            v-model="editForm.CampusIds"
                            multiple
                            filterable
                            :collapse-tags="(editForm.CampusIds || []).length > 5"
                            placeholder="请选择校区"
                            class="cq-admin-campus-select"
                            style="width: 100%"
                        >
                            <el-option v-for="item in campusOptions" :key="item.Id" :label="campusLabel(item)" :value="item.Id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="启用状态">
                        <el-switch v-model="editForm.Enabled"></el-switch>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="editForm.Remark" :rows="3" maxlength="500" placeholder="选填"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="editSubmit" :loading="editLoading">确 定</el-button>
                </div>
            </el-dialog>

            <person-scope-picker-dialog
                :visible.sync="personPickerVisible"
                directory-scope="internal"
                :show-scope-tabs="false"
                :scope-department-id="resolveSchoolId()"
                :value="editForm.TeacherMasterId"
                :label="selectedPersonLabel"
                @confirm="onPersonPicked"
            />
        </section>
    </section>
</template>

<script>
import { getCampusList } from '../../api/modules/misc';
import {
    getClassroomQualityAdminList,
    saveClassroomQualityAdmin,
    deleteClassroomQualityAdmin,
} from '../../api/modules/classroom-quality';
import { resolveActiveSchoolId } from '../../utils/deptCascaderProps';
import { getButtonList } from '../../promissionRouter';
import Toolbar from '../../components/Toolbar';
import DepartmentPane from '../../components/DepartmentPane';
import PersonScopePickerDialog from '../../components/PersonScopePickerDialog';

export default {
    name: 'ClassroomQualityAdmin',
    components: { Toolbar, DepartmentPane, PersonScopePickerDialog },
    data() {
        return {
            filters: { name: '' },
            searchList: [{ label: '姓名', key: 'name' }],
            campusOptions: [],
            rows: [],
            total: 0,
            page: 1,
            pageSize: 10,
            listLoading: false,
            buttonList: [],
            departmentId: 0,
            dialogTitle: '',
            editFormVisible: false,
            editLoading: false,
            personPickerVisible: false,
            selectedPersonLabel: '',
            editFormRules: {
                TeacherMasterId: [{
                    validator: (rule, value, callback) => {
                        // TeacherMasterId 可能是雪花 Id，勿用 Number() 判断。最后修改：2026-10-18
                        const key = value != null && value !== '' ? String(value).trim() : '';
                        if (!key || key === '0') callback(new Error('请选择教职工'));
                        else callback();
                    },
                    trigger: 'change',
                }],
                CampusIds: [{
                    type: 'array',
                    required: true,
                    min: 1,
                    message: '请至少选择一个校区',
                    trigger: 'change',
                }],
            },
            editForm: {
                Id: 0,
                SchoolId: 0,
                TeacherMasterId: 0,
                TeacherName: '',
                Enabled: true,
                Remark: '',
                CampusIds: [],
            },
        };
    },
    methods: {
        formatCampuses(row) {
            const list = (row.Campuses || []).map(c => c.CampusName || c.campusName).filter(Boolean);
            return list.length ? list.join('、') : '-';
        },
        /**
         * 校区下拉显示名：名称为空时退回简称，再退回「未命名校区（Id）」。最后修改：2026-10-12
         */
        campusLabel(item) {
            const name = String((item && (item.Name || item.ShortName)) || '').trim();
            return name || `未命名校区（${item && item.Id}）`;
        },
        resolveSchoolId() {
            // 学校 Id 用字符串，避免大整型精度丢失。最后修改：2026-10-18
            const fromStore = resolveActiveSchoolId(this);
            if (fromStore) return String(fromStore);
            if (this.departmentId) return String(this.departmentId);
            return '';
        },
        treeNodeClick(data) {
            const nextId = data && (data.value != null ? data.value : data.Id);
            const nextKey = nextId != null && nextId !== '' ? String(nextId) : '';
            if (!nextKey) return;
            if (String(this.departmentId || '') === nextKey && this.departmentId) return;
            this.departmentId = nextKey;
            this.loadCampusOptions();
            this.handleQuery();
        },
        handleQuery() {
            this.page = 1;
            this.getList();
        },
        getList() {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) return;
            this.listLoading = true;
            getClassroomQualityAdminList({
                schoolId,
                page: this.page,
                pageSize: this.pageSize,
                name: this.filters.name || '',
            }).then(res => {
                const resp = (res.data && res.data.response) || {};
                this.rows = resp.data || [];
                this.total = resp.dataCount != null ? resp.dataCount : this.rows.length;
            }).finally(() => {
                this.listLoading = false;
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
        callFunction(item) {
            if (typeof item.search === 'object') this.filters = { ...this.filters, ...item.search };
            else this.filters = { ...this.filters, name: item.search };
            if (item.Func && typeof this[item.Func] === 'function') this[item.Func]();
            else this.handleQuery();
        },
        loadCampusOptions() {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) return;
            getCampusList({ page: 1, intPageSize: 999, departmentId: schoolId }).then(res => {
                if (res.data && res.data.success) {
                    this.campusOptions = (res.data.response && res.data.response.data) || [];
                }
            });
        },
        handleAdd() {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) {
                this.$message.warning('请先选择学校');
                return;
            }
            this.dialogTitle = '新增课堂质量管理员';
            this.selectedPersonLabel = '';
            this.editForm = {
                Id: 0,
                SchoolId: schoolId,
                TeacherMasterId: 0,
                TeacherName: '',
                Enabled: true,
                Remark: '',
                CampusIds: [],
            };
            this.editFormVisible = true;
            this.loadCampusOptions();
        },
        handleEdit(row) {
            this.dialogTitle = '编辑课堂质量管理员';
            this.selectedPersonLabel = row.TeacherName || '';
            this.editForm = {
                Id: row.Id,
                SchoolId: row.SchoolId,
                TeacherMasterId: row.TeacherMasterId,
                TeacherName: row.TeacherName,
                Enabled: row.Enabled,
                Remark: row.Remark,
                CampusIds: (row.Campuses || []).map(c => c.CampusId),
            };
            this.editFormVisible = true;
            this.loadCampusOptions();
        },
        handleDel(row) {
            this.$confirm('确认删除该管理员？', '提示', { type: 'warning' }).then(() => {
                deleteClassroomQualityAdmin({ id: row.Id }).then(res => {
                    if (res.data && res.data.success) {
                        this.$message.success(res.data.msg || '已删除');
                        this.getList();
                    } else {
                        this.$message.error((res.data && res.data.msg) || '删除失败');
                    }
                });
            }).catch(() => {});
        },
        openPersonPicker() {
            if (!this.resolveSchoolId()) {
                this.$message.warning('请先选择学校');
                return;
            }
            this.personPickerVisible = true;
        },
        clearSelectedPerson() {
            this.editForm.TeacherMasterId = 0;
            this.editForm.TeacherName = '';
            this.selectedPersonLabel = '';
        },
        onPersonPicked(person) {
            if (!person) return;
            this.editForm.TeacherMasterId = person.id;
            this.editForm.TeacherName = person.name || '';
            this.selectedPersonLabel = person.name || '';
            this.$nextTick(() => {
                if (this.$refs.editForm) this.$refs.editForm.validateField('TeacherMasterId');
            });
        },
        editSubmit() {
            this.$refs.editForm.validate(valid => {
                if (!valid) return;
                this.editLoading = true;
                saveClassroomQualityAdmin({
                    ...this.editForm,
                    SchoolId: this.resolveSchoolId(),
                }).then(res => {
                    if (res.data && res.data.success) {
                        this.$message.success(res.data.msg || '保存成功');
                        this.editFormVisible = false;
                        this.getList();
                    } else {
                        this.$message.error((res.data && res.data.msg) || '保存失败');
                    }
                }).finally(() => {
                    this.editLoading = false;
                });
            });
        },
    },
    mounted() {
        const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        if (!this.buttonList.some(b => b.Func === 'handleQuery')) {
            this.buttonList.unshift({ name: '查询', Func: 'handleQuery', id: 999 });
        }
    },
};
</script>

<style scoped>
.tip-bar {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 10px;
    padding: 8px 12px;
    background: #f4f8ff;
    color: #4b5563;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.5;
}
.ps-pick-summary {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}
.muted-text { color: #909399; }
.form-tip { margin-top: 4px; color: #909399; font-size: 12px; }
/* 未折叠时标签换行完整展示，避免挤成一行看不见。最后更新：2026-10-31 */
.cq-admin-campus-select >>> .el-select__tags {
    max-width: 100%;
    white-space: normal;
}
.cq-admin-campus-select >>> .el-select__tags > span {
    display: inline-flex;
    flex-wrap: wrap;
    max-width: 100%;
}
</style>
